// Contas do registo de recebimentos de um negócio, uma parte de cada vez (cada consultor tem a sua).
// Usa as mesmas regras do módulo Comissões e Recebimentos (src/ComRec.js):
// - a agência só pode receber da parte de cada consultor até ao valor do reporting dele;
// - o consultor só recebe sobre o que a agência já recebeu da parte dele.
import { r2, faltaAgencia } from "./ComRec";

const num = (v) => Number(v || 0);
// Formato único em todo o ecrã: "8 750 €" (o toLocaleString pt-PT não agrupa números de 4 algarismos)
export const eurTxt = (v) => {
  const n = Math.round(num(v) * 100) / 100;
  const [inteiro, dec] = Math.abs(n).toFixed(2).split(".");
  const milhares = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
  const cents = dec === "00" ? "" : "," + dec.replace(/0$/, "");
  return (n < 0 ? "-" : "") + milhares + cents + "\u00A0€";
};

// Quanto este consultor pode receber agora, contando com o que a agência vai receber neste mesmo registo
export function maximoAgente(o, agNovo = 0) {
  const rec = num(o.rec) + num(agNovo);
  const cMax = num(o.r) > 0 ? r2(rec * num(o.c) / num(o.r)) : 0;
  return Math.max(0, r2(cMax - num(o.cRec)));
}

export function funcaoDe(o) {
  const fs = o.fs || [];
  if (fs.includes("A") && fs.includes("C")) return "Pleno";
  return fs.includes("A") ? "Angariador" : fs.includes("C") ? "Comprador" : "";
}

// valores: { [chave do consultor]: { ag, dAg, agente, dAgente } } (texto vindo dos campos)
// Devolve os erros escritos por campo e se o registo está vazio.
export function validarRecebimento(internas, valores) {
  const erros = {};
  let total = 0;
  internas.forEach((o) => {
    const v = valores[o.k] || {};
    const ag = num(v.ag), ge = num(v.agente);
    const e = {};
    if (ag < 0) e.ag = "O valor não pode ser negativo.";
    if (ge < 0) e.agente = "O valor não pode ser negativo.";
    if (ag > 0) {
      if (!v.dAg) e.dAg = "Indique a data em que o cliente pagou.";
      const max = faltaAgencia(o);
      if (ag > max + 0.005) e.ag = max > 0 ? `Só faltam ${eurTxt(max)} da parte de ${o.nome}.` : `A parte de ${o.nome} já está toda paga.`;
    }
    if (ge > 0) {
      if (!v.dAgente) e.dAgente = "Indique a data em que o consultor recebeu.";
      const max = maximoAgente(o, ag);
      if (ge > max + 0.005) e.agente = max > 0 ? `${o.nome} só pode receber ${eurTxt(max)} agora, sobre o que a agência já recebeu.` : `${o.nome} só recebe depois de a agência receber a parte dele.`;
    }
    if (Object.keys(e).length) erros[o.k] = e;
    total += Math.max(0, ag) + Math.max(0, ge);
  });
  return { erros, vazio: total <= 0, total: r2(total) };
}

// Reparte um valor pago pelo cliente pelas partes que ainda faltam (proporcional ao que falta de cada uma)
export function repartirCliente(total, internas) {
  const t = r2(total);
  const faltas = internas.map((o) => faltaAgencia(o));
  const soma = r2(faltas.reduce((s, f) => s + f, 0));
  const out = {};
  if (!(t > 0) || !(soma > 0)) { internas.forEach((o) => { out[o.k] = 0; }); return out; }
  let restante = Math.min(t, soma);
  const ultimo = faltas.map((f, i) => (f > 0 ? i : -1)).filter((i) => i >= 0).pop();
  internas.forEach((o, i) => {
    if (faltas[i] <= 0) { out[o.k] = 0; return; }
    const parte = i === ultimo ? restante : Math.min(faltas[i], r2(Math.min(t, soma) * faltas[i] / soma));
    out[o.k] = r2(parte);
    restante = r2(restante - out[o.k]);
  });
  return out;
}

// Tudo recebido: a agência recebeu a parte de cada consultor e cada consultor recebeu a sua comissão
export function comissaoRecebida(internas) {
  return internas.length > 0 && internas.every((o) => num(o.r) > 0 && faltaAgencia(o) <= 0.01 && num(o.c) - num(o.cRec) <= 0.01);
}

export const modoDeRecebimento = (ag, agente) => (num(ag) > 0 && num(agente) > 0 ? "ambos" : num(ag) > 0 ? "cliente" : "consultor");
